var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.policy
    ? _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.policy.title))]),
          _vm._v(" "),
          _c("v-card-text", {
            domProps: { innerHTML: _vm._s(_vm.policy.content) },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }